import React from 'react';

const FooterSection = ({ t, setLang }: any) => (
  <footer className="footer">
    <div className="footer-links">
      <a href="#about">{t.about}</a>
      <a href="#race-info">{t.raceInfo}</a>
      <a href="#register">{t.register}</a>
      <a href="/results">{t.results}</a>
      <a href="#volunteers">{t.volunteers}</a>
      <a href="#contact">{t.contact}</a>
    </div>
    <div className="footer-lang-selector">
      <button onClick={() => setLang('en')}>EN</button>
      <button onClick={() => setLang('mk')}>MK</button>
      <button onClick={() => setLang('al')}>AL</button>
    </div>
    <div className="footer-legal">
      <span>{t.cookieNotice}</span>
      <span>{t.copyright}</span>
    </div>
  </footer>
);

export default FooterSection;
